<template>
    <div class="container full_width py-lg-3">
        <div class="title title_mod">
            <h2 class="font-active mb-0">Shop By Metal</h2>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
                <div class="title">
                    <h2 class="font-active">Shop By Metal</h2>
                </div>
                <div class="content">
                    <p :key="currentMetal.title + '-title'" :class="['content_title', 'font-active', 'info_box', { active: true } ]">{{ currentMetal.title }}</p>
                    <p :key="currentMetal.title + '-desc'" :class="['desc', 'info_box', { active: true }]">{{ currentMetal.desc }}</p>

                    <div class="metals metal_color">
                        <div class="metal_box white" 
                            @click="selectMetal(metals[0])" 
                            :class="{ active: currentMetal.title === metals[0].title }">
                        </div>
                        <div class="metal_box yellow" 
                            @click="selectMetal(metals[1])" 
                            :class="{ active: currentMetal.title === metals[1].title }">
                        </div>
                        <div class="metal_box rose" 
                            @click="selectMetal(metals[2])" 
                            :class="{ active: currentMetal.title === metals[2].title }">
                        </div>
                        <div class="metal_box platinum" 
                            @click="selectMetal(metals[3])" 
                            :class="{ active: currentMetal.title === metals[3].title }">
                        </div>

                    </div>
                </div>
                <div class="banner_btn">
                    <NuxtLink 
                    class="anker radious_four" 
                    :to="localePath({ name: 'cyo-setting-list-ring', params: { start_with: currentMetal.link } })">
                    Create your own
                </NuxtLink>
                <NuxtLink class="anker radious_four" :to="localePath({ name: 'preset-listing' , query: { 'Metal': currentMetal.predesigned }})">Shop pre-designed
                    </NuxtLink>
                </div>
            </div>
            <div class="col-12 col-lg-5">
                <div :class="{ active: currentMetal.title }" class="text-center diamond_box">
                        <img :src="currentImageSrc" width="430" height="357" alt="Shop By Metal Image" />
                    </div>
            </div>
        </div>  
    </div>
</template>


<script setup>
    const metals = [
        { title: 'White Gold', desc: 'White gold, available in 14KT and 18KT, is one of the most popular metal choices for lab grown engagement rings due to its lasting durability and shiny platinum-like lustre.',
        link : 'white-gold-engagement-rings', predesigned : '14KtWhiteGold'
         },
        { title: 'Yellow Gold', desc: 'Yellow gold, available in 14KT and 18KT, adds a traditional and classic touch to engagement rings and pairs well with darker skin tones to provide an eye-catching contrast. ',
        link : 'yellow-gold-engagement-rings', predesigned : '14KtYellowGold'
         },
        { title: 'Rose Gold', desc: 'Rose gold, available in 14KT and 18KT, is a subtle and exquisite metal that adds a feminine charm to all ring styles including traditional, modern, and vintage designs.',
        link : 'rose-gold-engagement-rings', predesigned : '14KtRoseGold'
         },
        { title: 'Platinum', desc: 'Platinum, known for its purity, has a beautiful white reflective appearance and is resistant to tarnish and corrosion, making it one of the most desirable metals for modern couples.',
        link : 'platinum-engagement-rings', predesigned : 'Platinum'
         },
    ];
        //  :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'white-gold-engagement-rings' } })"
        //  :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'yellow-gold-engagement-rings' } })"
        //  :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'rose-gold-engagement-rings' } })"
        // :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'platinum-engagement-rings' } })"


    const localePath = useLocalePath();
    const currentMetal = ref(metals[0]);

    const selectMetal = (metal) => {
        currentMetal.value = metal;
    };
        
    const currentImageSrc = computed(() => {
        if (currentMetal.value.title === 'White Gold' || currentMetal.value.title === 'Platinum') {
            return '/shopmetal/white.jpg';
        } else if (currentMetal.value.title === 'Yellow Gold') {
            return '/shopmetal/yellow.jpg';
        } else if (currentMetal.value.title === 'Rose Gold') {
            return '/shopmetal/rose.jpg';
        }
    });

</script>

<style scoped>
.diamond_box {
    height: 0;
    overflow: hidden;
    transition: height 1s ease-out;
}
.img_part {
    overflow: hidden;
    transition: height 1s ease-out;
}
.diamond_box.active {
    height: 100%;
    transition: height 1s ease-out;
}
h2 {
    font-size: 36px;
    font-weight: 400;
    text-align: left;
    color: #212529;
}

.content_title {
    font-size: 24px;
}

.content {
    padding: 25px 0;
}

.desc {
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #606060;
    min-height: 75px;
}

.metals {
    display: flex;
    /* padding: 25px 0; */
}

.banner_btn {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.banner_btn a {
    padding: 12px 20px;
    font-size: 14px;
    min-width: 210px;
    text-align: center;
    color: #353535;
    letter-spacing: 1.5px;
    font-weight: 700;
    text-transform: uppercase;
    border: 1.5px solid #353535;
    flex-grow: 1;
    margin-right: 3%;
}

.banner_btn a:last-child {
    margin-right: 0;
}

.metal_color .metal_box {
    height: 25px;
    width: 25px;
    /* margin-right: 5px; */
    cursor: pointer;
    /* border: 2px solid #fff; */
    border-radius: 4px;
}

.metal_color .metal_box.active {
    height: 25px;
    width: 25px;
    border: 1px solid #606060;
}

.metal_color {
    gap: 8px;
}

.metal_color .yellow {
    background: #f3dda1;
}

.metal_color .rose {
    background: #f3b089;
}

.metal_color .white,
.metal_color .platinum {
    background: #eff0f0;
}

.img_part img {
    object-fit: cover;
    max-width: 100%;
}
.img_part{
    overflow: hidden;
    transition: height 1s ease-out;
}

.title_mod {
    display: none;
}

@media (max-width:991px) {
    .title {
        display: none;
    }

    .title_mod {
        display: block;
    }

    .title_mod h2 {
        font-size: 24px;
        margin-bottom: 20px !important;
    }

    .row {
        flex-direction: column-reverse;
    }

    h2 {
        font-size: 24px;
        min-height: 20px;
        text-align: center;
    }

    .content_title {
        font-size: 20px;
        text-align: center;
        margin: 16px 0 0;
    }

    .desc {
        font-size: 14px;
        text-align: center;
        margin: 12px 0;
        min-height: 0;
        /* margin: 0 5px 12px; */
    }

    .metals {
        justify-content: center;
    }

    .banner_btn {
        display: flex;
        justify-content: center;
        gap: 8px;
        flex-direction: column;
        padding: 0 15%;
    }

    .banner_btn a {
        margin-right: 0;
    }

    .content {
        padding: 0 15px;
    }

    .metals {
        padding: 0 0 24px;
    }
    p.desc.info_box.active {
        min-height: 65px;
    }
}

@keyframes slideUpFadeIn {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.info_box {
    opacity: 0;
    transform: translateY(20px);
}

.info_box.active {
    animation: slideUpFadeIn 0.5s ease forwards;
}

</style>